// extracted by mini-css-extract-plugin
export default {"avatar":"i_CiF","lg":"WRJN3","text":"vmIem","md":"KUuCH","sm":"C7Sle","preview":"IjDVU"};